import { render, staticRenderFns } from "./BookNowAlt.vue?vue&type=template&id=216f64f6&"
import script from "./BookNowAlt.vue?vue&type=script&lang=js&"
export * from "./BookNowAlt.vue?vue&type=script&lang=js&"
import style0 from "./BookNowAlt.vue?vue&type=style&index=0&id=216f64f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CartCountdownAltAuto: require('/opt/build/repo/components/Cart/CountdownAltAuto.vue').default,UIClearPay: require('/opt/build/repo/components/UI/ClearPay.vue').default,CoursesPurchaseButton: require('/opt/build/repo/components/Courses/PurchaseButton.vue').default})
